import { isFunction } from 'lodash-es'
import mitt from 'mitt'
import { randomString } from '../../../api/common/sharedUtils.js'

const spa = mitt()
const wsHandlers = {}
let _token, _userId, _wsSessionId, socket, socketConnectedFn


async function initWs({ token, userId }) {
    console.log('initWs...')
    _token = token
    _userId = userId
    _wsSessionId = randomString(16)
    if (process.env.KN_WS_ENDPOINT === 'http://localhost:3333') {
        if (socket) socket.disconnect(true) // true to prevent reconnecting
        socketConnectedFn = s => s?.connected

        const { io } = await import('socket.io-client')
        socket = io(process.env.KN_WS_ENDPOINT, {
            extraHeaders: {
                'x-kinectin-userId': userId,
                'x-kinectin-ws-session-id': _wsSessionId,
            },
        })
        socket.on('connect', () => {
            if (!socket.id) console.log('no socket id')
            if (socket.id === undefined) console.log('socket id undefined')
            console.log(`socket connected with id = ${socket.id}`)
        })
        socket.on('message', ({ messageType, payload }) => {
            const fn = wsHandlers[messageType]
            if (isFunction(fn)) fn(payload)
        })
        socket.on('disconnect', (reason) => {
            console.log(`socket disconnected with reason = ${reason}`)
        })
        socket.on('error', async (err) => {
            console.error('Socket error:', err)
            console.log('attempting to refresh session...')
            const { getUserSession } = await import('@/service/UserService.js')
            const resp = await getUserSession()
            console.log(resp)
        })
    } else {
        if (socket) socket.close()
        socketConnectedFn = s => s?.readyState === WebSocket.OPEN

        socket = new WebSocket(
            process.env.KN_WS_ENDPOINT
            + '?token=' + encodeURIComponent(token)
            + '&wssessionid=' + encodeURIComponent(_wsSessionId)
        )
        socket.addEventListener('open', () => {
            console.log('Connected to WebSocket')
        })
        socket.addEventListener('message', (event) => {
            const { messageType, payload } = JSON.parse(event.data)
            const fn = wsHandlers[messageType]
            if (isFunction(fn)) fn(payload)
        })
        socket.addEventListener('close', (event) => {
            console.log('Disconnected from WebSocket', event)
        })
        socket.addEventListener('error', async (err) => {
            console.error('WebSocket error:', err)
            console.log('attempting to refresh session...')
            const { getUserSession } = await import('@/service/UserService.js')
            const resp = await getUserSession()
            console.log(resp)
        })
    }
}

spa.on('user-auth', initWs)

function checkConnection() {
    if (!socketConnectedFn) return // not initizlied yet

    if (!socketConnectedFn(socket)) {
        console.warn('WebSocket is not open. Attempting to reconnect...')
        handleReconnect()
    }
}
setInterval(checkConnection, 5000)

function handleReconnect() {
    setTimeout(() => initWs({ token: _token, userId: _userId }), 2000)
}

function addWsHandler({ messageType, fn }) {
    wsHandlers[messageType] = fn
}

function removeWsHandler({ messageType }) {
    delete wsHandlers[messageType]
}

function getWsSessionId() {
    return _wsSessionId
}

export default {
    getWsSessionId,
    spa,
    api: {
        addWsHandler,
        removeWsHandler,
    },
}